import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum FeedbackTabs {
	COMMENT = 'comment',
	RUBRIC = 'rubric',
	INFORMATION = 'information',
	TRANSCRIPTION = 'transcription',
	ANALYTICS = 'analytics',
}

@Injectable({
	providedIn: 'root'
})
export class FeedbackSessionService {
	private readonly isPanelOpenSubject = new BehaviorSubject<boolean>(false);
	private readonly activeTabSubject = new BehaviorSubject<FeedbackTabs>(
		FeedbackTabs.COMMENT
	);

	public readonly isPanelOpen$: Observable<boolean> = this.isPanelOpenSubject.asObservable();
	public readonly activeTab$: Observable<FeedbackTabs> = this.activeTabSubject.asObservable();

	constructor () {}

	public togglePanel (value?: boolean): void {
		const currentValue = this.isPanelOpenSubject.getValue();
		this.isPanelOpenSubject.next(value ?? !currentValue);
	}

	public setActiveTab (tab: FeedbackTabs): void {
		this.activeTabSubject.next(tab);
	}

	public getCurrentTab (): FeedbackTabs {
		return this.activeTabSubject.getValue();
	}

	public getIsPanelOpen (): boolean {
		return this.isPanelOpenSubject.getValue();
	}
}
